import Layout from './Layout';
import Error from './Error';
import HeaderTitle from './HeaderTitle';

export default {
	Error,
	HeaderTitle,
	Layout,
};
